import { useCallback } from 'react';
import { type Editor } from '@tiptap/react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { EquationIcon } from '@/icons';
import { Button } from '@/ui_v3/components/button';
import { openEquationEditorModal } from '../EquationEditorModal';
export const EquationButton = ({
  editor,
  className
}: {
  editor: Editor | null;
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const handleInsertEquation = useCallback((latex: string) => {
    editor?.commands.insertContent(`<math-inline data-latex="${latex}"></math-inline>`);
  }, [editor]);
  const handleClickEquationButton = useCallback(async () => {
    const latex = await openEquationEditorModal({
      initialValue: ''
    });
    if (latex) {
      handleInsertEquation(latex);
      logger.track('build_addformula', {
        location: 'question'
      });
    }
  }, [handleInsertEquation]);
  return <Button className={className} leftSlot={<EquationIcon size="xs" fill="#7A7B89" />} onMouseDown={e => {
    e.stopPropagation();
  }} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    void handleClickEquationButton();
  }} variant="transparent" intent={'neutral'} size="xs" data-sentry-element="Button" data-sentry-component="EquationButton" data-sentry-source-file="EquationButton.tsx">
      {t('build:build.equationModal.header')}
    </Button>;
};